import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const TheMostFashionableOlympicsEver = lazy(() => import('../pages/blog/the-most-fashionable-olympics-ever/page'));
const TopFiveGlobalMarketingTrends = lazy(() => import('../pages/blog/top-5-global-marketing-trends/page'));
const BrandMagicParisOlympics = lazy(() => import('../pages/blog/brand-magic-paris-olympics/page'));


const CALDMediaPlanningPage = lazy(() => import('../pages/cald-media-planning/page'));
const CaldSocialPage = lazy(() => import('../pages/cald-social/page'));
const CostEfficiencySolutionsPage = lazy(() => import('../pages/cost-efficiency-solutions/page'));
const EventsPlanningPage = lazy(() => import('../pages/events-planning/page'));

const MediaPlanningPage = lazy(() => import('../pages/media-planning/page'));

const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/the-most-fashionable-olympics-ever',
    element: <TheMostFashionableOlympicsEver />,
  },
  {
    path: '/blog/top-5-global-marketing-trends',
    element: <TopFiveGlobalMarketingTrends />,
  },
  {
    path: '/blog/brand-magic-paris-olympics',
    element: <BrandMagicParisOlympics />,
  },
  
  
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/cald-media-planning',
    element: <CALDMediaPlanningPage />,
  },
  {
    path: '/cald-social',
    element: <CaldSocialPage />,
  },
  {
    path: '/cost-efficiency-solutions',
    element: <CostEfficiencySolutionsPage />,
  },
  {
    path: '/events-planning',
    element: <EventsPlanningPage />,
  },
  
  {
    path: '/media-planning',
    element: <MediaPlanningPage />,
  },
  
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;